export const isRecordStringUnknown = (obj)=>{
    return !!(obj && typeof obj === 'object' && !Array.isArray(obj) && !(obj instanceof Promise));
};

//# sourceMappingURL=isRecordStringUnknown.js.map